export const TBL_HEADERS = [
  {
    name: "",
    variable: "",
  },
  {
    name: "Accession No #",
    variable: "",
  },
  {
    name: "First Name",
    variable: "",
  },
  {
    name: "Last Name",
    variable: "",
  },
  {
    name: "Date of Birth",
    variable: "",
  },
  {
    name: "New Lis Status",
    variable: "",
  },
  {
    name: "Action",
    variable: "",
  },
  {
    name: "Previous Lis Status",
    variable: "",
  },
  {
    name: "Collection Date",
    variable: "",
  },
  {
    name: "Received Date",
    variable: "",
  },
  // {
  //   name: "Upload Result",
  //   variable: "",
  // },
  // {
  //   name: "View",
  //   variable: "",
  // },
  // {
  //   name: "Instrument",
  //   variable: "",
  // },
  // {
  //   name: "Report",
  //   variable: "",
  // },
  // {
  //   name: "Print Label",
  //   variable: "",
  // },
  // {
  //   name: "Lab",
  //   variable: "",
  // },
  {
    name: "Facility Name",
    variable: "",
  },
];
